
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WWWRedirect = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Sprawdź, czy jesteśmy w środowisku przeglądarki
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      
      // Sprawdź, czy URL zawiera "www."
      if (hostname.startsWith('www.')) {
        // Utwórz nowy URL bez "www."
        const newHostname = hostname.replace('www.', '');
        const protocol = window.location.protocol;
        const port = window.location.port ? `:${window.location.port}` : '';
        const pathname = window.location.pathname;
        const search = window.location.search;
        const hash = window.location.hash;
        
        // Skonstruuj nowy URL
        const newUrl = `${protocol}//${newHostname}${port}${pathname}${search}${hash}`;
        
        console.log(`Przekierowanie z ${window.location.href} na ${newUrl}`);
        
        // Bezpośrednie przekierowanie na nowy URL przez window.location
        window.location.replace(newUrl);
      }
    }
  }, []);  // Usuń zależność od location.pathname, aby przekierowanie wykonało się tylko raz
  
  return null;
};

export default WWWRedirect;
